import { memo, useCallback, useState } from 'react'

import { Box, useTheme } from '@mui/material'

import { Button, Card, CheckboxNew, Divider, H2, PdfRenderer } from '@acre/design-system'

import { UnsetMarginWrapper } from '@broker-crm-common/Common.styles'

import { PdfDocWrapper } from './Eula.styles'

type EulaProps = {
  headerText: JSX.Element
  buttonText: JSX.Element
  checkboxText: JSX.Element
  doc: string
  loading: boolean
  onSubmit: () => void
}

type ControlsProps = Pick<EulaProps, 'buttonText' | 'checkboxText' | 'loading' | 'onSubmit'>

const Controls = ({ checkboxText, buttonText, loading, onSubmit }: ControlsProps) => {
  const [isSignedEula, setSignedEula] = useState<boolean>(false)
  const handleClick = useCallback(() => {
    setSignedEula(!isSignedEula)
  }, [isSignedEula])

  return (
    <>
      <CheckboxNew id={'123'} label={checkboxText} checked={isSignedEula} onChange={() => handleClick()} />
      <Box my={2}>
        <Button
          id="SubmitEulaConfirmation"
          type="button"
          buttonStyle="primary"
          fullWidth
          disabled={!isSignedEula}
          isLoading={loading}
          onClick={() => onSubmit()}
        >
          {buttonText}
        </Button>
      </Box>
    </>
  )
}

const EulaForm = ({ headerText, buttonText, checkboxText, doc, loading, onSubmit }: EulaProps) => {
  const theme = useTheme()

  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      <Box width={theme.wrappers.large} height={theme.wrappers.large} my={16}>
        <Card padding={`${theme.spacing(4)} ${theme.spacing(6)}`} border={false}>
          <Box mb={4}>
            <H2 styledAs="h4">{headerText}</H2>
          </Box>

          <UnsetMarginWrapper margin="size48">
            <Divider />
          </UnsetMarginWrapper>

          <Box mb={2} mt={4}>
            <PdfDocWrapper>
              <PdfRenderer id="Eula" base64={doc} showControls={false} showBorder={false} />
            </PdfDocWrapper>

            <Box mt={4}>
              <Controls checkboxText={checkboxText} buttonText={buttonText} loading={loading} onSubmit={onSubmit} />
            </Box>
          </Box>
        </Card>
      </Box>
    </Box>
  )
}

export default memo(EulaForm)
